(function ($, Drupal, drupalSettings) {

  Drupal.behaviors.mbo_product_info_001 = {
    attach: function (context) {

      // Open the popup.
      $('body').once('mbo_product_info_001--open-popup').on('click', '.mbo-product-info-001--cta-popup a,a.mbo-product-info-001--media-a', function (e) {
        if ($(window).outerWidth() >= 768 || $(this).closest('.view-id-mbf_products_001_list').hasClass('view-display-id-block_1')) {
          var prodRow = $(this).closest('.views-row');
          $('.mbo-product-info-001--paragraph-wrapper.mbo-product-info-001--version--product_info_popup', prodRow).addClass('opened').fadeIn(400);
          e.preventDefault();

          // Lock page scroll, nicescroll init fades.
          $.scrollLock(true);
          productScrollFadesInits();
        }
      });

      // Close the popup.
      $('body').once('mbo_product_info_001--close-popup').on('click', 'span.mbo-product-info-001--close', function (e) {
        $(this).closest('.mbo-product-info-001--paragraph-wrapper.mbo-product-info-001--version--product_info_popup').fadeOut(400, function () {
          $(this).removeClass('opened');
        });
        e.preventDefault();

        // Unlock page scroll.
        $.scrollLock(false);
      });
      $('body').once('mbo_product_info_001--close-overlay').on('click', '.mbo-product-info-001--paragraph--overlay', function() {
        $('span.mbo-product-info-001--close', $(this).closest('.mbo-product-info-001--paragraph-wrapper')).trigger('click');
      });

      // Increase and decrease quantity.
      $('body').once('mbo_product_info_001--quantity-decrease').on('click', '.quantity-plus-minus > span.mba-button:first-child', function() {
        var quantity = parseInt($('input', $(this).closest('.quantity-plus-minus')).val());
        if (quantity > 1) {
          $('input', $(this).closest('.quantity-plus-minus')).val(quantity - 1);

          var input = $('input', $(this).closest('.quantity-plus-minus'))[0];
          if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", true, true);
            input.dispatchEvent(evt);

            evt.initEvent("blur", true, true);
            input.dispatchEvent(evt);
          } else {
            input.fireEvent("onchange");
            input.fireEvent("onblur");
          }
        }
      });
      $('body').once('mbo_product_info_001--quantity-increase').on('click', '.quantity-plus-minus > span.mba-button:last-child', function() {
        var quantity = parseInt($('input', $(this).closest('.quantity-plus-minus')).val());
        $('input', $(this).closest('.quantity-plus-minus')).val(quantity + 1);

        var input = $('input', $(this).closest('.quantity-plus-minus'))[0];
        if ("createEvent" in document) {
          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", true, true);
          input.dispatchEvent(evt);
          //evt.initEvent("blur", true, true);
          //input.dispatchEvent(evt);
        } else {
          input.fireEvent("onchange");
          //input.fireEvent("onblur");
        }
      });

      // Size switching.
      $('.mbo-product-info-001--version--default .mbo-product-info-001--info,' +
        '.mbo-product-info-001--version--product_info_popup .mbo-product-info-001--info').once('mbo-product-info-001--info--move-price').each(function() {
        $(this).find('.field--name-price').insertAfter($(this).find('.variation-select'));
      });

      $('body').once('mbo-product-info-001--variations-default').on('change', '.mbo-product-info-001--version--default .variation-select input[type=radio]', function() {
        $('.mbo-product-info-001--version--default .variations-select select').val($('.mbo-product-info-001--version--default .variations-select select option:eq(' + $(this).attr('data-index') + ')').val()).trigger('change');
        $(this).parent().parent().parent().parent().find('.field--name-price').html($(this).attr('data-price'));
      });
      $('body').once('mbo-product-info-001--variations-popup').on('change', '.mbo-product-info-001--version--product_info_popup .variation-select input[type=radio]', function() {
        $('.mbo-product-info-001--version--product_info_popup:visible .variations-select select').val($('.mbo-product-info-001--version--product_info_popup:visible .variations-select select option:eq(' + $(this).attr('data-index') + ')').val()).trigger('change');
        $(this).parent().parent().parent().parent().find('.field--name-price').html($(this).attr('data-price'));
      });

      $('.mbo-product-info-001--version--product_info_list').once('mbo-product-info--range').each(function() {
        if ($(this).find('.variation-select').length) {
          var lowest = 0;
          var highest = 0;
          var exVat = '';

          $(this).find('input[type=radio]').each(function () {

            var price = $(this).attr('data-price').replace('£', '').replace(" <span class='vat-suffix'>ex VAT</span>", '');
            price = parseFloat(price);

            if (lowest === 0 || lowest > price) {
              lowest = price;
            }
            if (highest < price) {
              highest = price;
            }
            if ($(this).attr('data-price').indexOf(" <span class='vat-suffix'>ex VAT</span>") > 0) {
              exVat = " <span class='vat-suffix'>ex VAT</span>";
            }

          });

          $(this).find('.field--type-commerce-price').html('£' + lowest.toFixed(2) + ' - £' + highest.toFixed(2) + exVat);
        }
      });

      $('.infos--datasheets').once('mbo-product-info--datasheets-click').click(function () {
        $('.mbo-product-info-001--popup-datasheets', $(this).closest('.mbo-product-info-001--version--product_info_popup')).slideDown(400, function(){
          productScrollFadesInits();
        });
      });

      // Popup nicescroll scrollbar.
      $('.mbo-product-info-001--version--product_info_popup').each(function(index, value) {
        if (!$('.mbo-product-info-001--paragraph--content', value).hasClass('nicescroll-applied')) {

          var scrollId = $('.mbo-product-info-001--paragraph--content', value).attr('id');
          $('#' + scrollId).addClass('nicescroll-applied').niceScroll({
            autohidemode: 'leave',
            cursoropacitymax: 0.3,
            cursorcolor: '#FFFFFF',
            cursorwidth: '12px',
            zindex: 99999999,
            railpadding: {
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
            },
          });

          $('#' + scrollId).niceScroll().scrollstart(function(info) {
            var scrollId = $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--paragraph--content').attr('id');

            if ($('#' + scrollId).length &&
                (info.end.y === 0 ||
                $('#' + scrollId).getNiceScroll(0).page.maxh < 0)) {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-top').stop().fadeOut(300);
            } else {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-top').stop().fadeIn(300);
            }
            if ($('#' + scrollId).length &&
                (info.end.y === $('#' + scrollId).getNiceScroll(0).page.maxh ||
                $('#' + scrollId).getNiceScroll(0).page.maxh < 0)) {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-bottom').stop().fadeOut(300);
            } else {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-bottom').stop().fadeIn(300);
            }
          });

          $('#' + scrollId).niceScroll().scrollend(function(info) {
            var scrollId = $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--paragraph--content').attr('id');

            if ($('#' + scrollId).length &&
                (info.end.y === 0 ||
                $('#' + scrollId).getNiceScroll(0).page.maxh < 0)) {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-top').stop().fadeOut(300);
            } else {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-top').stop().fadeIn(300);
            }
            if ($('#' + scrollId).length &&
                (Math.ceil(info.end.y) === $('#' + scrollId).getNiceScroll(0).page.maxh ||
                $('#' + scrollId).getNiceScroll(0).page.maxh < 0)) {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-bottom').stop().fadeOut(300);
            } else {
              $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-bottom').stop().fadeIn(300);
            }
          });

        }
      });

      $(window).once('mbo_product_info_001--nicescroll-resize').resize(function () {
        productScrollFadesInits();
      });

      function productScrollFadesInits() {
        var scrollId = $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--paragraph--content').attr('id');

        if ($('#' + scrollId).length) {
            $('#' + scrollId).getNiceScroll().resize();

          if ($('#' + scrollId).getNiceScroll(0).page.maxh > 0) {
            $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-bottom').fadeIn(300);
          } else {
            $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-bottom').hide();
          }
        }

        $('.mbo-product-info-001--version--product_info_popup:visible .mbo-product-info-001--fade-top').hide();
      }

    },
  };

})(jQuery, Drupal, drupalSettings);
